/**
 * Contains all the data points related to leftnav upsell
 */
export default {
    HeaderPremiumDiamond: {
        datapoint: {
            name: 'HeaderPremiumDiamondDisplayed',
        },
    },
    HeaderPremiumDiamondClicked: {
        datapoint: {
            name: 'HeaderPremiumDiamondClicked',
        },
    },
};
//# sourceMappingURL=datapoints.js.map